import React, { useEffect, useState } from 'react'
import type { TFunction } from 'i18next'
import {
  PriceEvolutionChart,
  PriceEvolutionByCategory,
} from '../../../PriceEvolutionChart'
import { usePurchaseMarket } from '../../PurchaseMarketContext'

interface PriceEvolutionProps {
  t: TFunction
}

export const PriceEvolution: React.FC<PriceEvolutionProps> = ({ t }) => {
  const { filters, service } = usePurchaseMarket()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [data, setData] = useState<PriceEvolutionByCategory>({})

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setError(null)

      try {
        // Determine location type and value from filters
        let locationType = undefined
        let locationValue = undefined

        if (filters.location) {
          switch (filters.locationType) {
            case 'postal_code':
              locationType = 'postal_code_name'
              break
            case 'city':
              locationType = 'municipality_name'
              break
            case 'district':
              locationType = 'district_name'
              break
          }
          locationValue = filters.location
        }

        const apiFilters = {
          deal_type: 'purchase',
          property_category:
            filters.propertyCategory.length > 0
              ? filters.propertyCategory
              : undefined,
          location: locationValue,
          location_type: locationType,
          outlier_field: 'price',
          outlier_percentage: 2,
        }

        const response = await service.getPriceEvolutionData(apiFilters)

        // Pass the raw aggregations data directly to the component
        setData(response.aggregations)
      } catch (err) {
        console.error('Error fetching price evolution data:', err)
        setError(t('market.common.errors.loadingData'))
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [filters])

  return (
    <PriceEvolutionChart
      data={data}
      loading={loading}
      error={error}
      isRental={false}
      showKPIs={false}
      showInsights={false}
      showControls={true}
      showQuantileChart={false}
      t={t}
    />
  )
}
